/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { useQueryStringParams } from '@modules/utils/qs'

import type { CCMClusterPageFilterQueryStringParams, CCMClusterPageFilters } from './types'

const useCCMClusterSearchFiltersFromQueryString = () => {
  const { queryStringItems: filters, setQueryStringItems } =
    useQueryStringParams<CCMClusterPageFilterQueryStringParams>()

  const activeQueryStringFilters: CCMClusterPageFilters = {
    organizationId: filters.organizationId ?? '',
    selfManagedClusterId: filters.selfManagedClusterId ?? '',
    licenseId: filters.licenseId ?? '',
    includeDisconnected: filters.includeDisconnected === 'true',
    includeInternalUsers: filters.includeInternalUsers === 'true',
  }

  return {
    activeQueryStringFilters,
    setQueryStringFilters: (newFilters: CCMClusterPageFilters) => {
      setQueryStringItems({
        ...newFilters,
        includeDisconnected: newFilters.includeDisconnected ? 'true' : undefined,
        includeInternalUsers: newFilters.includeInternalUsers ? 'true' : undefined,
      })
    },
  }
}

export default useCCMClusterSearchFiltersFromQueryString
